var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockLime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#A5DA05"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 26,
    width: 23,
    height: 17,
    rx: 3.5,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 26V22C21.5 18.7 24.4 16 28 16C31.6 16 34.5 18.7 34.5 22V26",
    stroke: "#1D1D1D",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 33.5,
    r: 2.3,
    fill: "#A5DA05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 34,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#A5DA05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLime);
export default __webpack_public_path__ + "static/media/lock_lime.f44459036dccac47d13a362643851b49.svg";
export { ForwardRef as ReactComponent };